import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  key: 0
};

var _hoisted_2 = /*#__PURE__*/_createTextVNode(" invited you to join ");

import { NotificationType } from "@/types/models/notification";
export default /*#__PURE__*/_defineComponent({
  props: {
    notification: null,
    depth: {
      default: 1
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_n_text = _resolveComponent("n-text");

      return _openBlock(), _createElementBlock("div", null, [__props.notification.type === _unref(NotificationType).GroupInvite ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_n_text, {
        strong: ""
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(__props.notification.payload.user.userName), 1)];
        }),
        _: 1
      }), _createVNode(_component_n_text, {
        depth: __props.depth
      }, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      }, 8, ["depth"]), _createVNode(_component_n_text, {
        strong: ""
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(__props.notification.payload.group.name), 1)];
        }),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
});